"use client";

import { createContext } from "react";
const UserContext = createContext();

export default UserContext;